<template>
    <v-app class="us-v-app">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goBack">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;">邀请新团员</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>
        <v-content>
            <v-container style="padding-top:2rem;">
              <v-card style="width:90%;margin:auto;" flat>
                <v-card-text style="text-align:center;">
                    <div style="font-size:1.6rem;margin-top:1rem;margin-bottom:1.8rem;line-height:2.2rem;">{{companyName}}</div>
                    <v-divider style="border-color:#eee;"></v-divider>
                    <div style="margin-top:1rem;margin-bottom:1rem;">扫一扫二维码， 加入团队</div>
                    <ShareQrCode ref="shareQrCode" title="邀请码" :visible.sync="shareVis" />
                    <div style="text-align:center;margin:0.5rem 0;color:#F56C6C;">
                        有效期 {{shareExpiry}} 分钟.
                    </div>
                </v-card-text>
              </v-card>
              <div style="margin-top:1rem;font-size:0.85rem;color:#808080;text-align:center;">提示：点击右上角分享二维码或链接</div>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import ShareQrCode from '../../components/ShareQrCodeV2'
import wx from 'weixin-js-sdk'
export default {
  components: {
    ShareQrCode
  },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      companyName: '',
      companyCode: '',
      shareExpiry: 10,
      role: 'common',
      shareVis: false
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.companyCode = that.$route.query.code
    that.companyName = that.$route.query.name
    that.shareExpiry = that.$route.query.expiry
    var qrcode = that.$route.query.qrcode
    // console.log('qrcode', qrcode);
    that.configShare();
    that.showInviteCode(qrcode)
  },
  created() {

  },
  methods: {
    goBack() {
      var that = this;
      that.$router.goBack()
    },
    // 显示邀请码
    showInviteCode(code) {
      var that = this
      that.$refs.shareQrCode.setQrContent(code)
      that.shareVis = !that.shareVis
    },
    // 配置分享
    configShare() {
      var that = this
      var sImage = that.$AppHelper.getShareLink('/res/favicon.png')

      that.$api.bz.createShareRecord({ expiry: that.shareExpiry }).then(res => {
        var shareCode = ''
        if (res.success) {
          shareCode = res.data
        }
        // that.$route.fullPath
        var shareLink = that.$AppHelper.getShareLink('/JoinCompanyShare?company_code=' + that.companyCode + '&share_code=' + shareCode);
        wx.updateAppMessageShareData({
          title: '《' + that.companyName + '》团队 邀请您加入',
          desc: '有效期' + that.shareExpiry + '分钟',
          link: shareLink,
          imgUrl: sImage,
          success: function() {
          // 设置成功
            console.log('配置分享内容.OK');
          },
          error: function() {
            console.log('配置分享内容.ERROR');
          }
        })
      })
    }

  }
}
</script>

<style scoped>
.us-v-app{
  background-color: #f2f2f2;
}
</style>
